import { createContext } from 'react';
import type { StartOutcome } from '@financialharmony/show-and-tell';
import type { Support } from '@/lib/showAndTell/capability';

export type ShowAndTellStatus =
  | 'idle'
  | 'recording'
  | 'paused'
  | 'capped'
  | 'mic-lost'
  | 'uploading'
  | 'upload-failed';

export interface ShowAndTellFailure {
  /** A sentence the backend wrote for the user; absent for any other failure, which the control words itself. */
  message?: string;
  reference?: string;
}

export interface ShowAndTellApi {
  support: Support;
  status: ShowAndTellStatus;
  /** Active recording time in ms; excludes paused time. */
  elapsedMs: number;
  uploadPercent: number;
  failure: ShowAndTellFailure | null;
  /** Starts recording. `note` is an optional typed note saved with the recording (F8). */
  start: (note: string) => Promise<StartOutcome | 'unsupported'>;
  pause: () => void;
  resume: () => void;
  send: () => Promise<void>;
  retryUpload: () => Promise<void>;
  cancel: () => void;
  discard: () => void;
}

export const ShowAndTellContext = createContext<ShowAndTellApi | null>(null);
